import React from "react";
import ReactDOM from "react-dom";
import List from "./List";
import "./index.css";
import Footer from "./components/footer/Footer";

ReactDOM.render(
  <React.Fragment>
    <List />
    <Footer />
  </React.Fragment>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js